import React from 'react'
import PdfViewer from '../PdfViewer'

const ContentPdfViewer = ({data, idSection}) => (
  <PdfViewer idSection={idSection} parentContentData={data} />
)

export default ContentPdfViewer